import {
    ODataHeader,
    ODataString,
    ODataDateTime,
    ODataInteger,
    ODataBoolean
} from "pbas-vue-components";

import { i18n } from '@/plugins/i18n';

const T4AArchiveHeaders = [
    new ODataHeader({
        type: new ODataString("Id"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        version: 1
    }),
    new ODataHeader({
        title: "headers.t4a_archive.year",
        type: new ODataInteger("Year"),
        sortable: true,
        visible: true,
        searchable: true,
        isIdentifier: true
    }),
    new ODataHeader({
        title: "YearId",
        type: new ODataString("YearId"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        title: "PlanId",
        type: new ODataString("PlanId"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        title: "IsRevised",
        type: new ODataBoolean("IsRevised"),
        sortable: false,
        visible: false,
        searchable: false,
        allowVisibilityChange: false,
        version: 1
    }),
    new ODataHeader({
        title: "globals.action",
        type: new ODataString("Action", {
            getString: (item) => i18n.t('enums.'+item.Action)
        }),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.timestamp",
        type: new ODataDateTime("Timestamp"),
        sortable: true,
        visible: true,
        searchable: true,
    }),
    new ODataHeader({
        title: "headers.pension_regulators.user",
        type: new ODataString("CreatedBy"),
        sortable: true,
        visible: true,
        searchable: true,
    }),
];
export default T4AArchiveHeaders;